<section [id]="fields.scroll_anchor_id" class="hero-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-xl-6 col-lg-6 col-md-10">
        <div class="hero-content">
          <h1>{{fields.headline}}</h1>
          <p>{{fields.subheadline}}</p>

        </div>
      </div>
      <div class="col-xxl-6 col-xl-6 col-lg-6">
        <div class="hero-image text-center text-lg-end">
          <img [src]="fields.image" alt="">
        </div>
      </div>
    </div>
  </div>
</section>
